export const COOKIE_NAME = "app_session_id";

/**
 * Names of the APX practice entities themselves as they appear in Xero.
 * These must be excluded from client counts and client lists — they are
 * the accounting firm entities, not client organizations.
 */
export const PRACTICE_ENTITY_NAMES: string[] = [
  "APX - HRB",
  "APX-HRB",
  "APX Advisors LLC",
  "APX Advisors",
  "APX ADVISORS LLC",
  "APX ADVISORS",
  "BBN NETWORK",
  "BBN FINANCIAL",
  "APX - BBN",
  "APX-BBN",
];

/** Returns true if the given name matches a known practice entity */
export function isPracticeEntity(name: string): boolean {
  const normalized = name.trim().toLowerCase();
  return PRACTICE_ENTITY_NAMES.some(e => e.toLowerCase() === normalized);
}
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'APX_SESSION_EXPIRED_10001';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

// Deploy: due-date-fix 2026-08-06
